import React from 'react';
import {Filter, TextInput, FilterProps } from 'react-admin';

const ModalFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput label='resources.admin/modals.fields.title' source="title" alwaysOn />
    </Filter>
);

export default ModalFilter;
